import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { FormAuthComponent } from './form-auth/form-auth.component';
import {
  MatInputModule,
  MatButtonModule,
} from '@angular/material';

@NgModule({
  declarations: [FormAuthComponent],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    FormsModule,
    MatInputModule,
    MatButtonModule,
  ],
  exports: [FormAuthComponent]
})
export class FormAuthModule { }
